import Patient from '@/types/Patient';

export enum AnmeldungStatus {
    Angelegt = 'A',
    Verarbeitet = 'V',
}

export default class Anmeldung {
    public anmeldung_id: number | null = null;
    public datum: string | null = null;
    public zeit: string | null = null;
    public nachname: string | null = null;
    public vorname: string | null = null;
    public titel: string | null = null;
    public titel_nach_name: string | null = null;
    public geburtsdatum: string | null = null;
    public geschlecht: string | null = null;
    public svnr: string | null = null;
    public strasse: string | null = null;
    public plz: string | null = null;
    public ort: string | null = null;
    public land: string | null = null;
    public email: string | null = null;
    public telefon: string | null = null;
    public anforderung_id: number | null = null;
    public hinweis: string | null = null;
    public dsgvo_einverstaendnis: string | null = null;
    public dsgvo_bemerkung: string | null = null;
    public impfstelle_id: number | null = null;
    public status: AnmeldungStatus | null = null;

    public patient: Patient | null = null;

    constructor(data?: Partial<Anmeldung>) {
        Object.assign(this, data);
    }
}
